import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * @return {null}
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  if (process.env.APP_ENV !== 'server' && typeof window === 'object') {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  }

  return null;
};

export default ScrollToTop;



// WEBPACK FOOTER //
// ./src/components/common/ScrollToTop/ScrollToTop.js